import axios from "~/plugins/axios";

export default {
  getConnectProviders() {
    const url = "/web_api/v1/aplaza_register/connect_providers";

    return axios.get(url).then((response) => response.data);
  },
};
